import { MessageCircle } from 'lucide-react';

export default function StudentMessages() {
  return (
    <div className="py-6 space-y-6">
      <div>
        <h1 className="text-2xl font-bold text-[#EBFFEE]">Messages</h1>
        <p className="text-sm text-[#A9A3A3] mt-1">Direct and group conversations with your gym community.</p>
      </div>

      <div className="bg-[#221F1F] border border-[#504A4A] rounded-xl p-12 flex flex-col items-center justify-center text-center">
        <div className="w-16 h-16 rounded-full bg-white/5 flex items-center justify-center mb-4">
          <MessageCircle className="w-8 h-8 text-[#A9A3A3]" />
        </div>
        <h2 className="text-lg font-semibold text-[#EBFFEE]">Messaging Coming Soon</h2>
        <p className="text-sm text-[#A9A3A3] mt-2 max-w-md">
          Send direct messages and participate in group conversations with your coaches and training partners.
        </p>
      </div>
    </div>
  );
}
